// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","image":"button_image__LSJ5t","label":"button_label__++F+J"};